import Navbar from  "./components/Navbar"
import Header from "./components/Header"
import About from "./components/About"
import Services from "./components/Services"
import Skills from "./components/Skills"
import Projects from "./components/Projects"
import Testimonial from "./components/Testimonial"
import Contact from "./components/Contact"
import Footer from "./components/Footer"
import AnalyticsFloat from "./components/AnalyticsFloat";
import AnalyticsModal from "./components/AnalyticsModal";
import { useState } from "react"

function App() {
   const [openAnalytics, setOpenAnalytics] = useState(false);
  return (
    <>
    <Navbar/>
    <Header/>
    <About/>
    <Services/>
    <Skills/>
    <Projects/>
    <Testimonial/>
    <Contact/>
    <Footer/>
    <AnalyticsFloat onOpen={() => setOpenAnalytics(true)} />
    <AnalyticsModal open={openAnalytics} onClose={() => setOpenAnalytics(false)} period="30d" />
    </>
  );
}

export default App;
